<template>
  <div class="p-card-body">
    <DataTable
      :value="commissionLists"
      :paginator="true"
      :rows="8"
      class="p-datatable-responsive p-datatable-customers"
    >
      <Column header="S.N" > <template #body="slotProps">
          {{slotProps.index+1}}
         </template></Column>
      <Column header="Commision Name" field="commissionName" filterField="comissionName" filterMatchMode="contains"/>
      <Column header="Commission Type" field="type" />
      <Column header="Quantity From" field="fromQty"/>
      <Column header="Quantity To" field="toQty"/>
        <Column header="Action" field>
          <template #empty>No record found</template>
          <template #body="slotProps">
            <Button icon="pi pi-pencil" class="p-button-success p-button-sm" @click="editCommision(slotProps.data)"/>
            <Button icon="pi pi-trash" class="p-button-danger p-button-sm" @click="openDialog(slotProps.data.id)"/>
          </template>
        </Column>
    </DataTable>
    <!-- </div> -->
    <DeleteDialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCommision"/>
      </div>
  <!-- </section> -->
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DeleteDialog from '../../../layout/dialog'
import Button from 'primevue/button'
export default {
  name: 'ListCommision',
  data () {
    return {
      dialogShow: false,
      deleteReason: '',
      commisionId: null,
      show: false
    }
  },
  computed: {
    commissionLists() {
      return this.$store.state.itemMaster.commissionLists
    }
  },
  mounted() {
    this.commisionList()
  },
  methods: {
    async commisionList() {
      await this.$store.dispatch('listOfCommission')
    },
    async deleteCommision(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        id: this.commisionId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteCommision', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        let message = {
          message: resp.data.message,
          messageType: 'success'
        }
        this.$emit('delete-message', message)
      } else {
        let message = {
          message: resp.data.message,
          messageType: 'warn'
        }
        this.$emit('delete-message', message)
      }
      this.closeDialog()
    },
    editCommision(data) {
      this.$emit('edit-commision', data)
    },
    cancel(data) {
      this.show = false
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.commisionId = id
    },
    closeDialog() {
      this.dialogShow = false
      this.deleteReason = ''
    }
  },
  components: {
    DataTable,
    Column,
    DeleteDialog,
    Button
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// commisionList.vue?7f63381e